import { Box } from '@chakra-ui/layout'
import { } from 'containers'
import JsBarcode from 'jsbarcode'
import { connectNetwork } from 'lib/NetworkProvider'
import { routes } from 'lib/routes'
import moment from 'momentconfig'
import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import ReactToPrint from 'react-to-print'
import { Button, Icon, Modal, Table } from 'semantic-ui-react'
import SummarySheet from '../job/SummarySheet'
import { mapOrdToOrdering } from '../lib/util'
import MasterDropdown from '../utility/MasterDropdown'

const { app, masters, masterEdit } = routes

class Master extends Component {
    constructor(props) {
        super(props)

        let { onCostChange, master } = props

        this.state = {
            deleting: false,
            ...master,
            masterMinutes: master ? parseFloat(master.masterMinutes) : 0,
        }

        if (onCostChange && master) {
            onCostChange(this.totalCost(), master.masterId)
        }
    }

    totalCost() {
        let { masterPrice } = this.state
        let total = masterPrice
        if (isNaN(total)) {
            total = 0
        }
        return total
    }

    componentDidMount() {
        let { master, masterId, network } = this.props

        if ((!master || !master.masterId) && masterId) {
            network.getMaster(masterId)
        }
    }

    renderBalanceFooter() {
        return <Table.Row></Table.Row>
    }

    renderBalanceHeader() {
        return <Table.Header fullWidth></Table.Header>
    }

    renderForBalance() {
        return <Table.Row></Table.Row>
    }

    renderTableFooter() {
        let { isBalance } = this.props
        if (isBalance) return this.renderBalanceFooter()
        else return null
    }

    renderTableHeader() {
        let {
            onMasterCodeHeaderClick,
            onMasterSupplierHeaderClick,
            hideMaster,
            hideMasterName,
            hideMasterSupplier,
            hideBarcode,
            hideActions,
            isBalance,
            sorts
        } = this.props
        if (isBalance) {
            return this.renderBalanceHeader()
        } else {
            return (
                <Table.Header fullWidth>
                    <Table.Row>
                        {!hideMaster && (
                            <Table.HeaderCell
                                {...(sorts ? { sorted: sorts.masterCode ? mapOrdToOrdering[sorts.masterCode] : null } : {})}
                                onClick={onMasterCodeHeaderClick ? onMasterCodeHeaderClick : () => {}}
                            >
                                Codice
                            </Table.HeaderCell>
                        )}
                        {!hideMasterName && <Table.HeaderCell>Master</Table.HeaderCell>}
                        {!hideMasterSupplier && (
                            <Table.HeaderCell
                                {...(sorts ? { sorted: sorts.masterSupplier ? mapOrdToOrdering[sorts.masterSupplier] : null } : {})}
                                onClick={onMasterSupplierHeaderClick ? onMasterSupplierHeaderClick : () => {}}
                            >
                                Fornitore
                            </Table.HeaderCell>
                        )}
                        {!hideBarcode && <Table.HeaderCell>Codice a barre</Table.HeaderCell>}
                        {!hideActions && <Table.HeaderCell>Azioni</Table.HeaderCell>}
                    </Table.Row>
                </Table.Header>
            )
        }
    }

    renderForTable() {
        let { hideMaster, hideMasterName, hideMasterSupplier, hideBarcode, isBalance, hideActions, onRowClick } = this.props
        let { masterId, masterCode, masterName, masterPercent, masterPrice, masterSupplier, masterSupplierId } = this.state

        setImmediate(() => {
            try {
                const text = masterCode
                JsBarcode(`#mastbarcode${masterCode}`, text, {
                    format: 'CODE128',
                    // lineColor: '#0aa',
                    // width: 4,
                    // height: 40,
                    // displayValue: false,
                })
            } catch (e) {
                console.error(e)
            }
        })

        if (isBalance) {
            return this.renderForBalance()
        } else {
            return (
                <Table.Row>
                    {!hideMaster && <Table.Cell>{masterCode}</Table.Cell>}
                    {!hideMasterName && <Table.Cell>{masterName}</Table.Cell>}
                    {!hideMasterSupplier && <Table.Cell>{masterSupplier}</Table.Cell>}
                    {!hideBarcode && (
                        <Table.Cell>
                            <div className="barcode-container" ref={(el) => (this.componentRef = el)}>
                                <svg id={`mastbarcode${masterCode}`}></svg>
                            </div>
                        </Table.Cell>
                    )}
                    {!hideActions && this.state.masterId && (
                        <Table.Cell>
                            <SummarySheet type="master" objectToSerialize={this.state} />
                            <Button
                                icon
                                color="yellow"
                                onClick={(e) => {
                                    this.setState({
                                        mergingMaster: true,
                                    })
                                    e.stopPropagation()
                                }}
                            >
                                <Icon name="exchange" />
                            </Button>
                            <Button
                                icon
                                color="blue"
                                onClick={(e) => {
                                    if (onRowClick) {
                                        onRowClick(this.state)
                                    }
                                    e.stopPropagation()
                                }}
                            >
                                <Icon name="edit" />
                            </Button>
                            <Button
                                icon
                                color="red"
                                onClick={(e) => {
                                    this.props.network.deleteMaster({
                                        masterId,
                                        masterCode,
                                        masterName,
                                        masterPercent,
                                        masterPrice,
                                        masterSupplier,
                                        masterSupplierId,
                                    })
                                    e.stopPropagation()
                                }}
                            >
                                <Icon name="remove" />
                            </Button>
                            <ReactToPrint
                                trigger={() => {
                                    return (
                                        <Button icon color="grey">
                                            <Icon name="print" />
                                        </Button>
                                    )
                                }}
                                content={() => this.componentRef}
                            />
                        </Table.Cell>
                    )}
                </Table.Row>
            )
        }
    }

    openRemoveDialog() {
        this.setState({ deleting: true })
    }

    remove() {
        let { network, master } = this.props

        network.deleteStdMaster(master)

        this.setState({ deleting: false })
    }

    render() {
        let { mergeDestinations, mergingMaster, masterId } = this.state
        let { login, type, master, onClick, selected, noActions } = this.props

        let extraprops = {
            fluid: type === 'full' ? true : false,
        }

        if (onClick) {
            extraprops.onClick = () => {
                onClick(master)
            }
        }

        let content = null
        switch (type) {
            case 'footer':
                content = this.renderTableFooter()
                break
            case 'header':
                content = this.renderTableHeader()
                break
            case 'table':
                content = this.renderForTable()
                break
            default:
                content = <Box borderWidth="1px" borderRadius="lg"
                    p="4" overflow="hidden" className={selected ? 'rowSelected' : ''} style={styles.masterCard} {...extraprops} />
                break
        }

        return (
            <>
                <Modal key={`modal_master_${masterId}`} closeIcon open={!!mergingMaster} onClose={() => this.setState({ mergingMaster: false })}>
                    <Modal.Header>Modificando master</Modal.Header>
                    <Modal.Content>
                        <MasterDropdown
                            selected={mergeDestinations}
                            onChange={(ev, data, selected, masters) => {
                                this.setState({
                                    mergeDestinations: masters,
                                })
                            }}
                            onlySelection
                        />
                        <Button
                            style={{ marginTop: 16 }}
                            color="red"
                            onClick={() => {
                                this.props.network.mergeMaster({
                                    sourceId: this.state.masterId,
                                    destinationId: this.state.mergeDestinations[0].masterId,
                                })
                                this.setState({ mergingMaster: false })
                            }}
                            disabled={
                                !this.state.mergeDestinations ||
                                this.state.mergeDestinations.length !== 1 ||
                                this.state.masterId === this.state.mergeDestinations[0].masterId
                            }
                        >
                            Effettua unione AZIONE IRREVERSIBILE, VERRA{'\''} ELIMINATO IL MASTER {'"'}{this.state.masterName}{'"'} ({this.state.masterId})
                        </Button>
                    </Modal.Content>
                </Modal>
                {content}
            </>
        )
    }
}

const styles = {
    header: {
        fontSize: '32pt',
        lineHeight: 'normal',
    },
    imageContainer: {
        minWidth: 200,
        minHeight: 150,
        marginRight: 28,
    },
    masterImage: {
        width: 200,
        height: 150,
        objectFit: 'contain',
    },
    masterContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    masterCard: {
        marginTop: 8,
        marginBottom: 8,
    },
}

const mapStateToProps = (state) => {
    let { login, getMaster } = state
    let rmasterId = null
    if (login && login.data && login.data.user) rmasterId = login.data.user.rmasterId

    return { role: rmasterId, getMaster, login }
}

export default withRouter(connect(mapStateToProps)(connectNetwork(Master)))
